<template>
    <div class="publicMain" id="twoNetworkConvergence">
        <el-card>
            <el-row :gutter="16" class="box2">
                <el-col :span="12">
                    <!-- <el-row :gutter="16">
                        <el-col>
                            选择指标：
                            <el-tag
                                size="mini"
                                effect="dark"
                                v-for="(item,index) in tags"
                                :key="index"
                            >{{item.label}}</el-tag>
                        </el-col>
                    </el-row>-->
                    <div class="mapBox" style="height:360px;margin:8px 0;">
                        <jiankongditu @setOrgId="setOrgId" @cks="cks" style="height:100%;width100%" />
                        <!-- <div class="onebuttom" id="tucontainer" ref="mapdt" style="height:100%"></div> -->
                    </div>
                    <!-- <el-row :gutter="16">
                        <el-col>
                            功能选项：
                            <el-tag
                                size="mini"
                                v-for="(item,index) in modules"
                                :key="index"
                                :type="item.type"
                                effect="dark"
                                @click="moduleClick(item.flag)"
                            >{{item.label}}</el-tag>&nbsp;
                        </el-col>
                    </el-row>-->
                </el-col>
                <el-col :span="12">
                    <el-pagination
                        :hide-on-single-page="true"
                        :total="pageConfig.total"
                        @current-change="handleCurrentChange"
                        :current-page="pageConfig.pageNo"
                        :page-size="pageConfig.pageSize"
                        layout="prev,next"
                    ></el-pagination>
<!--                    <el-row :gutter="16" class="listBox" v-if="!bigVideo">-->
<!--                        &lt;!&ndash;                        <video src="rtmp://localhost/oflaDemo/test22"></video>&ndash;&gt;-->
<!--                       <el-col-->
<!--                            :span="8"-->
<!--                            v-for="(item,index) in monitors"-->
<!--                            :key="'s'+item.url.substring(item.url.length - 6)+index+Math.ceil(Math.random()*10000000)"-->

<!--                        >-->
<!--                            <videoR-->
<!--                                :address="item.url"-->
<!--                                :id="'s'+item.url.substring(item.url.length - 6)+index+Math.ceil(Math.random()*10000000)"-->
<!--                                height="100%"-->
<!--                            />-->
<!--                        </el-col>-->


<!--                    </el-row>-->
                    <el-row :gutter="16" class="listBox" v-if="bigVideo">
                        <!--                        <video src="rtsp://admin:fkyl20190320@112.28.79.144:554/Streaming/Channels/2?transportmode=unicast"></video>-->
                        <el-col :span="24" class="bigVideo">
                            <videoR
                                    :address="bigUrl"
                                    :id="'b'+bigUrl.substring(bigUrl.length - 6)+Math.ceil(Math.random()*10000000)"
                                    height="370px"
                            />
<!--                            <i class="bigClose el-icon-circle-close" @click="closeBigVideo"></i>-->
                        </el-col>


                    </el-row>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <p>网格员情况</p>
                    <div class="box">
                        <el-row class="list-title">
                            <el-col :span="5">网格员</el-col>
                            <el-col :span="7">初定路线</el-col>
                            <el-col :span="7">实际路线</el-col>
                            <el-col :span="5">联系电话</el-col>
                        </el-row>
                        <!-- <el-row class="list" v-for="(item,index) in personTables" :key="index">
                            <el-col :span="5">{{item.gridManName}}</el-col>
                            <el-col :span="9">{{item.preliminaryRoute}}</el-col>
                            <el-col :span="5">{{item.actualRoute}}</el-col>
                            <el-col :span="5">{{item.inspectionTimes}}</el-col>
                        </el-row> -->
                         <el-row class="list" v-for="(item,index) in wgList" :key="index">
                            <el-col :span="5">{{item.name}}</el-col>
                            <el-col :span="9">&nbsp;</el-col>
                            <el-col :span="5">&nbsp;</el-col>
                            <el-col :span="5">{{item.mobile}}</el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="8">
                    <p>设备信息情况</p>
                    <div class="box">
                        <el-row class="list-title">
                            <el-col :span="16">设备编号</el-col>
                            <el-col :span="8">设备名称</el-col>
                            <!-- <el-col :span="5">状态</el-col>
                            <el-col :span="5">在线时长</el-col>-->
                        </el-row>
                        <!-- <el-row class="list" v-for="(item,index) in monitors" :key="index">
                            <el-col :span="16">{{item.cameraIndexCode}}</el-col>
                            <el-col :span="8">{{item.cameraName}}</el-col>
                            
                        </el-row> -->
                        <el-row class="list">
                            <el-col :span="16">xx-001</el-col>
                            <el-col :span="8">小区监控1号</el-col>
                        </el-row>
                        <el-row class="list">
                            <el-col :span="16">xx-002</el-col>
                            <el-col :span="8">小区监控2号</el-col>
                        </el-row>
                        <el-row class="list">
                            <el-col :span="16">xx-003</el-col>
                            <el-col :span="8">小区监控3号</el-col>
                        </el-row>
                        <el-row class="list">
                            <el-col :span="16">xx-004</el-col>
                            <el-col :span="8">小区监控4号</el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="8">
                    <p>投诉与建议</p>
                    <div class="box">
                        <el-row class="list-title">
                            <el-col :span="18">名称</el-col>

                            <el-col :span="6">上报人</el-col>
                            <!-- <el-col :span="5">联系电话</el-col> -->
                        </el-row>
                        <el-row class="list" v-for="(item,index) in tsList" :key="index">
                            <el-col :span="18" v-if="item.content">{{item.content}}</el-col>
                            <el-col :span="18" v-if="!item.content">暂无内容</el-col>
                            <el-col :span="6">{{item.fkName}}</el-col>
                           
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <!-- 弹出框查看异常 -->
        <el-dialog title="查看异常" :visible.sync="errorDialog.off" width="600px">
            <el-form
                label-position="right"
                size="mini"
                label-width="120px"
                :model="errorDialog.form"
            >
                <video
                    v-if="errorDialog.form.video !=''"
                    :src="errorDialog.form.video"
                    style="width:560px;height:300px"
                    controls="controls"
                >您的浏览器不支持视频播放</video>
                <el-row :gutter="16" style="margin-top:10px;">
                    <el-col :span="8">设备编号：{{errorDialog.form.eventNumber}}</el-col>
                    <el-col :span="8">设备位置：{{errorDialog.form.eventPosition}}</el-col>
                    <el-col :span="8">等级：一般</el-col>
                </el-row>
                <el-row :gutter="16" style="margin-top:6px;">
                    <el-col>异常内容：{{errorDialog.form.eventContent}}</el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" style="margin: 0 30px" @click="saveData">新增案件</el-button>
                <el-button type="info" size="small" @click="errorDialog.off = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import AMap from "AMap"; // 引入高德地图
import { post } from "@/api/requrestHttp.js";
import videoR from "@/components/videoRtmp";
import jiankongditu from "@/views/governmentAffairschildren/theGridManagement/jiankongditu.vue";
export default {
    components: { videoR, jiankongditu },
    data() {
        return {
            flag: "publicSafety",
            tags: [],
            modules: [],
            monitors: [
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test22'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test06'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test11'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test12'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test10'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test07'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test05'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test17'},
                {url:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test08'}
            ],
            personTables: [],
            deviceTables: [],
            centerTables: [],
            errorDialog: {
                form: {},
                off: false,
                title: "",
                type: ""
            },
            pageConfig: {
                pageNo: 1,
                pageSize: 9,
                total: 0
            },
            formData: {
                    indexCode: "561fc4b0-6297-40ae-96d9-16c487ed09eb",
                    orgId: ""
            },
            regionIndexCodes: "561fc4b0-6297-40ae-96d9-16c487ed09eb",
            orgId: "",
            jk1:require('@/assets/images/jk1.jpg'),
            jk2:require('@/assets/images/jk2.jpg'),
            jk3:require('@/assets/images/jk3.jpg'),
            jk4:require('@/assets/images/jk4.jpg'),
            bigVideo:true,
            bigUrl:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test22',
            wgList:[],
            tsList:[]
        };
    },
    methods: {
        // //视频点击功能
        // videoClk(){
        //     alert('---')
        // },
        //切换功能
        moduleClick(flag) {
            this.modules.forEach((item, index) => {
                if (item.flag == flag) {
                    this.modules[index].type = "danger";
                    this.tags = item.tags;
                } else {
                    this.modules[index].type = "info";
                }
            });
        },
        //点击查看视频监控
        showDialog(row, flag) {
            this.errorDialog.off = true;
            this.errorDialog.form = {};
        },
        saveData() {
            this.errorDialog.off = false;
        },
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val;
            this.getCameraList();
        },
        setOrgId(data) {
            post("/admin/user/info/list", {
                orgId:data,
                pageSize:10,
                pageNo:1
            }).then(res => {
               this.wgList=res.content.list;
            });
            post("/admin/complaints/info/findComplaints", {
                orgId:data,
                pageSize:10,
                pageNo:1
            }).then(res => {
                this.tsList=res.content.list;
            });
        },
        getTou() {

        },
        //打开大监控
        cks(e){
            // alert(e.target._amap_id);
            let id = e.target._amap_id;
            if(e){
                this.bigVideo=false;
            }
            console.log('id',id)
            if(id==17){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test22';
            }else if(id==18){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test06';
            }else if(id==19){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test11';
            }else if(id==20){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test12';
            }else if(id==22){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test10';
            }else if(id==21){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test07';
            }else if(id==23){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test05';
            }else if(id==24){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test17';
            }else if(id==25){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test08';
            }
            console.log(this.bigUrl);
            console.log(this.bigVideo);
            const that=this;
            setTimeout(function(){
                that.bigVideo=true;
                console.log(that.bigVideo);
            }, 500);
        },
        //关闭大监控
        closeBigVideo(){
            if(this.bigVideo){
                // this.bigVideo=false;
            }

        },
        getCameraList() {
            post("/admin/streetPublicVideo/info/smallAreaCameraList", {
                ...this.pageConfig,
                regionIndexCodes: this.formData.indexCode
            }).then(res => {
                this.monitors = res.content.list;
                this.pageConfig.total = res.content.count;
            });
        },
        getGridmanList() {
            post("admin/streetPublicVideo/info/smallAreaGridmanList", {
                id: this.formData.orgId
            }).then(res => {
                this.personTables = res.content;
            });
        },
        getSuggestion() {
            post("/admin/problemSuggestion/info/list", {
                pageNo: 1,
                pageSize: 10
            }).then(res => {
                this.centerTables = res.content.list;
            });
        }
    },
    mounted() {
        this.setOrgId(4)
        // this.getSuggestion();
        //  this.monitors = [
        //             "rtmp://10.1.2.1:1935/live/openUrl/bBIVRBu",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bC2wbzW",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bCmo6Gs",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bCFGPwQ",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bD1glpK",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bDlZ3Us",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bDGHMpa",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bDZ9HRm",
        //             "rtmp://10.1.2.1:1935/live/openUrl/bEjSqm4"
        //         ];
        var that = this;
        // window.getSearch = function(indexCode) {
        //     that.regionIndexCodes = indexCode;
        //     console.log(indexCode);
        //     post("/admin/streetPublicVideo/info/smallAreaCameraList", {
        //         ...that.pageConfig,
        //         regionIndexCodes: indexCode
        //     }).then(res => {
        //         that.monitors = res.content.list;
        //         that.pageConfig.total = res.content.count;
        //     });
        // };
        // this.monitors = [];
        for (let i = 1; i < 10; i++) {
            // temp = { id: i, img: require("@/assets/images/community/tu2.png") };
            // this.monitors.push(temp);
        }
        this.modules = [
            {
                flag: "publicSafety",
                type: "danger",
                label: "公共安全",
                tags: [
                    { label: "火灾监控", value: "火灾监控" },
                    { label: "消防救援", value: "消防救援" },
                    { label: "防灾救灾", value: "防灾救灾" },
                    { label: "人员密集", value: "人员密集" }
                ]
            },
            {
                flag: "civilization",
                type: "info",
                label: "新时代文明实践",
                tags: [{ label: "小区管理", value: "小区管理" }]
            },
            {
                flag: "theGridManagement",
                type: "info",
                label: "综合网格化管理",
                tags: [{ label: "网格员", value: "网格员" }]
            },
            {
                flag: "surveillance",
                type: "info",
                label: "社区公共视频监控",
                tags: [
                    { label: "小街小巷安全监控", value: "小街小巷安全监控" },
                    { label: "门前三包", value: "门前三包" }
                ]
            },
            {
                flag: "faceMonitor",
                type: "info",
                label: "重点人员人脸布控",
                tags: [{ label: "重点人脸", value: "重点人脸" }]
            }
        ];
        this.tags = this.modules[0].tags;
        let temp = {};

        // post("/admin/stylistic/info/listStylisticCenter", {
        //     pageNo: 1,
        //     pageSize: 10,
        //     total: 0
        // }).then(res => {
        //     this.centerTables = res.content.list;
        // });
        // post("admin/streetPublicVideo/info/streetPublicVideo", {}).then(res => {
        //     this.monitors = res.content;
        // });
    }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/base.less";
.publicMain {
    height: auto;
    min-height: 100%;
}
.mapBox {
    width: 100%;
}
.el-card {
    background-color: transparent;
    border-style: none;
}
.el-select {
    width: 100%;
    height: 30px;
}
.list-title {
    padding: 6px;
    text-align: center;
    color: #fff;
    font-size: 14px;
}
.list {
    padding: 0px 6px;
    text-align: center;
    .el-col {
        color: #fff;
        font-size: 12px;
        line-height: 28px;
    }
}
#twoNetworkConvergence {
    background-image: url("../../../assets/images/twoNetworkConvergence/index_bg.png");
    background-size: 100% 100%;
}
.box {
    padding: 10px;
    background-image: url("../../../assets/images/twoNetworkConvergence/card_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-top: 16px;
    height: 320px;
}
.box2 {
    background-image: url("../../../assets/images/twoNetworkConvergence/map_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 20px 10px;
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-bottom: 16px;

    color: #fff;
    font-size: 14px;
    .el-tag {
        margin-bottom: 6px;
        margin-left: 8px;
        cursor: pointer;
    }
}
.el-col p {
    padding-left: 16px;
}
.listBox {
    margin: -8px;
    .el-col {
        padding: 8px;
        height: 140px;
    }
    a {
        display: block;
        width: 100%;
        position: relative;
        height: 100%;
    }
    img {
        cursor: pointer;
        height: 100%;
        width: 100%;
    }
}
.bigVideo{
    position: relative;
}
.bigClose{
    position: absolute;
    right: 15px;
    top: 15px;
    font-size: 24px;
}
.el-pagination {
    position: absolute;
    width: 50%;
    z-index: 99;
    /deep/.btn-prev {
        position: absolute;
        top: 180px;
        background-color: rgba(40, 120, 255, 0);
        color: #fff;
        border-radius: 14px;
        width: 28px;
        min-width: 28px;
        padding: 0px;
        text-align: center;
        .el-icon {
            font-size: 40px;
        }
    }
    /deep/.btn-next {
        position: absolute;
        top: 180px;
        right: 30px;
        background-color: rgba(40, 120, 255, 0);
        color: #fff;
        border-radius: 14px;
        width: 28px;
        min-width: 28px;
        padding: 0px;
        text-align: center;
        .el-icon {
            font-size: 40px;
        }
    }
    /deep/button:disabled {
        display: none;
    }
}
</style>
<style lang="less">
#twoNetworkConvergence {
    .el-select {
        margin-right: 16px;
    }
    .el-select .el-input__inner {
        background-color: #348bc2;
        border: 1px solid #3dc2ff;
        color: #fff;
    }
    .el-input__icon {
        color: #fff;
    }
    input::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #fff;
    }
    p {
        color: #fff;
    }
    .el-card__body {
        padding: 0px;
    }
    .mapEventContent {
        width: 200px;
        font-size: 0px;
        img {
            width: 100%;
        }
        a {
            width: 50%;
            display: inline-block;
            font-size: 14px;
            overflow: hidden;
        }
    }
    .amap-info-content {
        padding: 10px;
    }
    .amap-info-close {
        right: 10px !important;
    }
}
</style>
 